import * as React from 'react';
import { CnStatusTag } from '@/components/cn-tag';
import { CnBox } from '@/components/cn-box';
const tagStatusList = [
    'info',
    'success',
    'error',
    'warning',
    'invalid',
];
const getTagStatus = (status) => {
    if (tagStatusList.includes(status))
        return status;
    return 'info';
};
export const FormatTag = (props) => {
    const { mode, value } = props;
    if (!value)
        return React.createElement(React.Fragment, null, "- -");
    if (Array.isArray(value)) {
        const showNum = mode === 'simple' ? 3 : value.length;
        const hasMore = mode === 'simple' && value.length > showNum;
        return (React.createElement(CnBox, { className: "cn-ui-m-card-items-format-tag", direction: "row", wrap: true, spacing: 4 },
            value.slice(0, showNum).map((item) => (React.createElement(CnStatusTag, { status: getTagStatus(item.state) }, item.value))),
            hasMore ? (React.createElement("div", { className: "cn-ui-m-card-items-format-more" },
                showNum,
                "+")) : null));
    }
    if (typeof value === 'object') {
        return (React.createElement(CnStatusTag, { status: getTagStatus(value.state) }, value.value));
    }
    return React.createElement(CnStatusTag, { status: "info" }, value);
};
